import { useEffect, useState } from "react";

import { getInboxPage, INBOX_CHANGED_EVENT } from "@/lib/documentInbox";

export function InboxNavBadge() {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    let controller: AbortController | null = null;
    function refresh() {
      controller?.abort(); controller = new AbortController();
      const signal = controller.signal;
      getInboxPage(new URLSearchParams("statuses=novo&statuses=predlozeno&limit=1"), signal)
        .then((page) => { if (!signal.aborted) setCount(page.total); }).catch(() => { /* Keep the last successful count on transient errors. */ });
    }
    refresh();
    const timer = window.setInterval(refresh, 30000);
    window.addEventListener(INBOX_CHANGED_EVENT, refresh);
    return () => { controller?.abort(); window.clearInterval(timer); window.removeEventListener(INBOX_CHANGED_EVENT, refresh); };
  }, []);
  return count === null ? null : <span className="ml-2 rounded-full bg-white/20 px-2 text-xs" aria-label={`${count} neobrađenih dokumenata`}>{count}</span>;
}
